/**
 * @fileOverview Find scroll parent
 */

export default (node: Element): Element  => {
    if (!node) {
        return document.documentElement;
    }

    const excludeStaticParent = (node as HTMLElement).style.position === 'absolute';
    const overflowRegex = /(scroll|auto)/;
    if (!(node instanceof Element)) {
        // If it's not an Element (e.g., if it's the window), return it directly or handle as needed
        return node;
    }

    let parent: Node | null = node;

    while (parent) {
        if (!parent.parentNode) {
            return (node.ownerDocument || document).documentElement;
        }

        const style = window.getComputedStyle(parent as Element);
        const position = style.position;
        const overflow = style.overflow;
        const overflowX = style.overflowX ;
        const overflowY = style.overflowY;

        if (position === 'static' && excludeStaticParent) {
            parent = parent.parentNode;
            continue;
        }

        if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
            return parent as Element;
        }

        parent = parent.parentNode;
    }

    return (node.ownerDocument || document).documentElement;
}
